import React from 'react'
import CartSectionHome from '../component/Cart Section/CartSectionHome'

const Cart = () => {
  return (
    <CartSectionHome/>
  )
}

export default Cart
